import { configureStore } from '@reduxjs/toolkit';
import clockSlice from '../features/clock/clockSlice';
import weightSlice from '../weight/weightSlice';
import transientSlice from '../features/transient/transientSlice';
import slotsSlice from '../features/slots/slotsSlice';
import { Scheduler } from '../scheduler';
import settingsSlice from '../weight/settingsSlice';
import countersSettingsSlice from '../features/counters/countersSettingsSlice';
import themeSlice from '../features/theme/themeSlice';
import slotsLayoutSlice from '../features/slots/slotsLayoutSlice';
import completionSlice from '../features/completion/completionSlice';
export const store = configureStore({
    reducer: {
        clock: clockSlice.reducer,
        weightins: weightSlice.reducer,
        transient: transientSlice,
        slots: slotsSlice,
        settings: settingsSlice.reducer,
        countersSettings: countersSettingsSlice.reducer,
        theme: themeSlice.reducer,
        slotsLayout: slotsLayoutSlice.reducer,
        completion: completionSlice.reducer
    }
});
// kick of the scheduler
const scheduler = Scheduler.getInstance();
scheduler.init(store);
scheduler.start();
